<template>
  <Alert
    :prominent="!$vuetify.breakpoint.mobile"
    color="info"
    icon="ph-fill ph-hourglass-high"
    outlined
  >
    <p v-html="$t('syncUsers.synchronizingUsers')"></p>
    <v-progress-linear
      color="#2C58A0"
      class="my-5 white--text"
      :value="progress"
      height="25"
      rounded
    >
      <strong>
        {{
          `${firstSyncUsersStatus.total_users_created} ${$t("common.of")} ${
            firstSyncUsersStatus.total_users
          }`
        }}
      </strong>
    </v-progress-linear>
  </Alert>
</template>

<script>
import Alert from "@/components/base/Alert.vue";
import { mapGetters } from "vuex";

export default {
  name: "SyncUsersAlert",
  components: {
    Alert,
  },
  computed: {
    ...mapGetters(["firstSyncUsersStatus"]),
    progress() {
      const { total_users, total_users_created } = this.firstSyncUsersStatus;
      return (total_users_created / total_users) * 100;
    },
  },
};
</script>
